import type { GenericOrderItem } from 'app/src/model'
import { GiftCardIcon, ShoppingCartIcon, VoucherIcon } from 'app/src/shared/components/Icons'
import { calculateDisplayValue, getNormalizedDetailsUrl } from 'app/src/shared/helpers'
import { useWelfarePortalNavigate } from 'app/src/shared/hooks'

import { DateTime } from 'luxon'
import { Button } from 'primereact/button'
import { Chip } from 'primereact/chip'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const errorLabels = ['Annullato', 'Rifiutato']

export function OrderListItemBigContent(props: { item: GenericOrderItem }): ReactElement {
  const { navigateDelegate } = useWelfarePortalNavigate()
  const { t } = useTranslation('productDetail')
  const orderDate = DateTime.fromISO(props.item.orderDate)
  const hasIcon =
    props.item.productTypology == 'giftCard' ||
    props.item.productTypology == 'goodAndService' ||
    props.item.productTypology == 'voucher'

  const getDiscountLabel = (discountType?: string): string => {
    if (discountType === 'percentage') {
      return t('ProductDetail.discount.percentage')
    } else if (discountType === 'fixed') {
      return t('ProductDetail.discount.fixed')
    }
    return t('ProductDetail.discount.generic')
  }

  const hangleNavigate = () => {
    if (props?.item?.detailsLink) {
      const normalizedUrl = getNormalizedDetailsUrl(props.item.detailsLink!)
      navigateDelegate(normalizedUrl)
    }
  }
  return (
    <div className='grid grid-cols-12 items-center gap-0'>
      <div className='col-span-1 grid grid-rows-3 border-r-[1px] text-center'>
        <div className='flex items-center justify-center'>
          <div className='h-[31.5px] text-[21px] font-bold'>{orderDate.toFormat('dd')}</div>
        </div>
        <div className='flex items-center justify-center'>
          <div className='text-4 h-[22px] font-bold'>{orderDate.toFormat('MMM').toUpperCase()}</div>
        </div>
        <div className='text-sm'>{orderDate.toFormat('yyyy')}</div>
      </div>

      <div className='col-span-11 ml-4'>
        <div className='grid grid-cols-12'>
          <div className={hasIcon ? 'col-span-1 self-center' : 'hidden'}>
            {props.item.productTypology == 'giftCard' ? (
              <GiftCardIcon />
            ) : props.item.productTypology == 'goodAndService' ? (
              <ShoppingCartIcon />
            ) : props.item.productTypology == 'voucher' ? (
              <VoucherIcon />
            ) : (
              <></>
            )}
          </div>
          <div className={hasIcon ? 'col-span-7 grid grid-rows-2' : 'col-span-8 grid grid-rows-2'}>
            <div className='mb-1'>
              <Chip
                pt={{
                  root: {
                    className: errorLabels.includes(props.item.status)
                      ? 'bg-[#fae8eb] text-[#BF0B20]'
                      : 'bg-[var(--card-background)] text-[var(--primary-color)]',
                  },
                }}
                label={props.item.status}
              />
            </div>
            <div className='pl-3'>
              <div className='text-lg font-semibold'>{props.item.productName}</div>
            </div>
          </div>
          <div className='col-span-2 grid grid-rows-2'>
            <div>{props.item.priceLabel === 'sconto' ? getDiscountLabel(props.item.discountType) : props.item.priceLabel}</div>
            <div>
              <div className='size-[21px] font-bold'>{calculateDisplayValue(props.item)}</div>
            </div>
          </div>
          <div className='col-span-2 self-center'>
            <Button
              rounded
              label={props.item.seeDetailsLabel}
              // the event normalizes the link removing the leading '#/' if present
              onClick={hangleNavigate}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
